import { readInterveneAudienceFilters } from './interveneFilters';

export function resolveFocusedUserDisplayName(username, agents = []) {
  const key = String(username || '').trim();
  if (!key) return '';
  const match = agents.find((agent) => agent.username === key);
  return match?.display_name || match?.label || key;
}

export function getInterveneMetricLabelOverrides(focusedUserDisplayName = '') {
  const name = String(focusedUserDisplayName || '').trim();
  if (!name) {
    return {
      avg_agent_response: 'Avg team response',
      median_agent_response: 'Median team response',
      avg_first_agent_response: 'Avg first reply',
      agent_reply_count: 'Team replies',
      outbound_human_count: 'Outbound (human)',
      session_count: 'Live sessions',
    };
  }
  const short = name.split(' ')[0] || name;
  return {
    avg_agent_response: `Avg response (${short})`,
    median_agent_response: `Median response (${short})`,
    avg_first_agent_response: `First reply (${short})`,
    agent_reply_count: `Replies by ${short}`,
    avg_customer_response: 'Avg customer response',
    outbound_human_count: 'Outbound (human)',
    session_count: 'Live sessions',
  };
}

export function getInterveneSectionTitles(focusedUserDisplayName = '') {
  const name = String(focusedUserDisplayName || '').trim();
  if (!name) {
    return {
      performance: 'Response performance',
      volume: 'Message volume',
      delivery: 'Delivery status',
    };
  }
  return {
    performance: `${name} — response times`,
    volume: `${name} — conversations`,
    delivery: 'Delivery status',
  };
}

export function buildInterveneAudienceCaption(filters = [], agents = []) {
  const { agent, customer } = readInterveneAudienceFilters(filters);
  const parts = [];
  if (agent) {
    parts.push(`User: ${resolveFocusedUserDisplayName(agent, agents)}`);
  }
  // Customer phone filter commented out per user request
  // if (customer) {
  //   parts.push(`Customer: ${customer}`);
  // }
  return parts.join(' · ');
}

export function buildIntervenePreviewTitle({
  metricLabel = '',
  focusedUserDisplayName = '',
  categoryLabel = '',
  showGroupBy = false,
}) {
  const metric = metricLabel || 'Overview';
  const user = String(focusedUserDisplayName || '').trim();
  if (user && !showGroupBy) {
    return `${user} · ${metric}`;
  }
  if (user && showGroupBy && categoryLabel) {
    return `${user} · ${metric} by ${categoryLabel}`;
  }
  if (showGroupBy && categoryLabel) {
    return `${metric} by ${categoryLabel}`;
  }
  return metric;
}
